import styles from './styles.module.scss'
import Button from '../../elements/Button'
import LazyImage from '../../elements/LazyImage'
import { getS3Url } from '../../helpers/getS3Url'
import { withModifiers } from '../../helpers/withModifiers'
import Link from 'next/link'
import isEmpty from 'lodash-es/isEmpty'
import { useState, useEffect } from 'react'
import moment from 'moment'

const formatDate = (date) => {
  if (!date) return ''
  const d = moment(date).utc()
  return d.format('dddd, MMMM D, YYYY')
}

const BlogCard = ({
  title,
  short_description,
  hero_image,
  categories,
  image,
  published_date,
  category,
  slug,
  cloudflare_hero_image,
  cloudflare_picture,
  date,
  variant = [],
  buttonLabel
}) => {
  const isSimilar = variant.includes('similar')
  const [formattedDate, setFormattedDate] = useState('')

  useEffect(() => {
    const formatDateString = async () => {
      const formatted = await formatDate(published_date || date)
      setFormattedDate(formatted)
    }
    formatDateString()
  }, [published_date, date])

  return (
    <article className={withModifiers('card', [...variant], styles)}>
      <Link href={`/stories/${slug}`}>
        <a className={styles.card__image}>
          <LazyImage
            sizes="(min-width: 1250px) 590px, (max-width: 1250px) 100vw, 50vw"
            layout="fill"
            objectFit="cover"
            objectPosition="center"
            src={getS3Url(
              cloudflare_picture ||
                cloudflare_hero_image ||
                hero_image ||
                image,
              '960'
            )}
          />
        </a>
      </Link>

      {isSimilar && (
        <div className={styles.card__details}>
          {(category || !isEmpty(categories)) && (
            <div className={styles.card__category}>
              {category || categories[0].title}
            </div>
          )}

          <div className={styles.card__date}>{formattedDate}</div>
        </div>
      )}

      {!isSimilar && <div className={styles.card__date}>{formattedDate}</div>}

      <h2 className={styles.card__title}>{title}</h2>

      {!isSimilar && (
        <div dangerouslySetInnerHTML={{ __html: short_description }}></div>
      )}

      {!isSimilar && categories && (
        <div className={styles.card__tag}>
          <em>{categories}</em>
        </div>
      )}

      <Button
        name={buttonLabel}
        href={`/stories/${slug}`}
        variant={['label', isSimilar && 'color-accent', isSimilar && 'primary']}
      >
        {buttonLabel}
      </Button>
    </article>
  )
}

export default BlogCard
